/**
 * 列表项
 * @desc 对cell系列组件的再封装
 * 
 * @param {String} label 标题
 * @param {String} prop 字段名
 * @param {String} type 功能类型['expand折叠', 'slide滑动', ''(default), 'selection选择'(in the future)]
 * 
 * @slots default 对应prop的值的插槽
 * @slots header 标题插槽
 * 
 * @scopedSlots {Object} default  slot-scope作用域
 * @scopedSlots {Object} default.column 表头数据
 * @scopedSlots {Object} default.row 行数据
 * @scopedSlots {Object} default.$index 所在行
 * @scopedSlots {Object} default.value 行数据中对应该prop的值
 */
export default {
    name: 'pp-list-item',
    props: {
        label: String, 
        prop: String,
        type: {
            type: String,
            default: '',
            validator: function(value) {
                return ['expand', 'slide', ''].includes(value);
            },
        },
        withMore: Boolean,
    },
    inject: {
        List: {
            default: '',
        },
    },
    computed: {
        hasParent: function() {
            return this.$parent.$options.name === 'pp-list';
        },
    },
    render: function(h) {
        return h('div', '');
    },
    mounted: function() {
        this.insert()
    },
    destroyed: function() {
        this.remove()
    },
    methods: {
        insert: function() {
            const h = this.$createElement;

            this.List.header.push({ 
                id: this._uid,
                label: this.label, 
                prop: this.prop,
                type: this.type,
                withMore: this.withMore,

                renderValue: (data, i)=> h(
                    'div', 
                    {
                        class: 'value',
                    }, 
                    this.$scopedSlots.default
                        ? this.$scopedSlots.default({
                                column: this.$props,
                                $index: i,
                                row: data,
                                value: this.$props.prop ? data[this.$props.prop] : undefined,
                            })
                        : this.$slots.default 
                            ? this.$slots.default 
                            : this.$props.prop ? data[this.$props.prop] : ''
                ),

                renderLabel: ()=> {
                    return h(
                    'div',
                    {
                        class: {
                            'label': true,
                        },
                    },
                    this.$slots.header || this.$props.label
                )},
            })
        },

        remove: function() {
            let i = this.List.header.findIndex(v=> v.id === this._uid);

            if(i !== -1) {
                this.List.header.splice(i, 1);
            }
        },
    },
}
